import { render, staticRenderFns } from "./RealityReminder.vue?vue&type=template&id=b0c955ae&scoped=true&"
import script from "./RealityReminder.vue?vue&type=script&lang=js&"
export * from "./RealityReminder.vue?vue&type=script&lang=js&"
import style0 from "./RealityReminder.vue?vue&type=style&index=0&id=b0c955ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c955ae",
  null
  
)

export default component.exports